import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CfssAgencyComponent } from './cfss-agency.component';


const routes: Routes = [ { path: '', component: CfssAgencyComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CFSSRoutingModule { }
